import { render, staticRenderFns } from "./PreparationsReportMailPopup.vue?vue&type=template&id=47085c05&"
import script from "./PreparationsReportMailPopup.vue?vue&type=script&lang=js&"
export * from "./PreparationsReportMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports